/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

/**
 * Displays an icon in `img` tag.
 * @props {String} src - The directly imported icon/image (Required)
 * @props {String} alt - The alt tag to be displayed (Required)
 * @props {Number} width - Width of the resolved `img` tag. (Optional | Default=25)
 */
const MenuIcon = ({ src, alt, width = 25 }) => (
  <img src={src} alt={alt} width={width} />
);

export default MenuIcon;
